import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {IconComponent} from '@components/ui/icon/item';

@NgModule({
  imports: [
    IonicModule,
    NgStyle,
    NgClass,
    NgIf
  ],
  exports: [
    IconComponent
  ],
  declarations: [
    IconComponent
  ],
  providers: [],
})
export class IconComponentModule {
}
